import React, { useEffect } from 'react';
import { TOAST_DURATION_MS } from '../../addSearchArgs';
import './AddConfirmation.css';

/** What the last add did, enough to describe it and take it back. */
export interface LastAdd {
  /** Monotonic, so a repeated add of the same printing restarts the timer. */
  key: number;
  cardName: string;
  /** "MID #264 · NM · Non-foil · EN", or just "MID #264" when the owner gives no settings line. */
  detailLine: string;
  thumbUrl: string;
  /** Removes exactly one copy of this add. */
  undo: () => Promise<void>;
}

interface Props {
  add: LastAdd | null;
  onUndo: () => void;
  onExpire: () => void;
}

/**
 * The add confirmation directly below the Add search box (Asana 1219423341660540,
 * Decision 12): thumbnail, "Added {name}", the printing and settings line, and
 * Undo. Never takes focus; stays TOAST_DURATION_MS; the next add replaces it.
 */
export const AddConfirmation: React.FC<Props> = ({ add, onUndo, onExpire }) => {
  useEffect(() => {
    if (!add) return undefined;
    const timer = setTimeout(onExpire, TOAST_DURATION_MS);
    return () => clearTimeout(timer);
  }, [add, onExpire]);

  return (
    <div className="add-confirmation-slot" aria-live="polite">
      {add && (
        <div className="add-confirmation" data-testid="add-confirmation" key={add.key}>
          <img className="add-confirmation__thumb" src={add.thumbUrl} alt="" width={26} height={36} />
          <div className="add-confirmation__text">
            <div className="add-confirmation__title">Added {add.cardName}</div>
            <div className="add-confirmation__detail">{add.detailLine}</div>
          </div>
          <button type="button" className="add-confirmation__undo" onClick={onUndo} tabIndex={-1}>
            Undo
          </button>
        </div>
      )}
    </div>
  );
};

export default AddConfirmation;
